'use client';

import Link from 'next/link';
import { LandingHeader } from '@/components/landing/header';
import { Button } from '@/components/ui/button';

const helpCards = [
    {
        icon: '📋',
        title: 'Documentation',
        description:
            'Master the Rudrise editor with our detailed guides, LaTeX tutorials, and API references.',
        buttonText: 'Browse Docs',
        href: '/documentation',
    },
    {
        icon: '🐛',
        title: 'Bug Report',
        description:
            'Encountered a glitch? Submit a report to help us improve the reliability of the editor for everyone.',
        buttonText: 'Report an Issue',
        href: '/bug-report',
    },
    {
        icon: '📧',
        title: 'Contact Us',
        description:
            "Can't find an answer? Reach out directly to our support team for personalized assistance.",
        buttonText: 'Email Support',
        href: '/contact-us',
    },
    {
        icon: '🎧',
        title: 'Open a Ticket',
        description:
            'Need immediate assistance or have complex issues? Open a support ticket for priority help.',
        buttonText: 'Create Ticket',
        href: '/support-tickets',
        grayscale: true,
    },
];

export default function LandingHomePage() {
    return (
        <>
            <main>
                {/* Hero Section */}
                <section className="bg-[#f5f7fb] dark:bg-background py-8 px-4">
                    <div className="max-w-5xl mx-auto">
                        {/* CARD CONTAINER */}
                        <div className="bg-white dark:bg-card rounded-3xl border border-gray-200 dark:border-border shadow-sm px-8 md:px-12 py-12 text-center">

                            {/* HEADING */}
                            <h1 className="text-4xl md:text-5xl font-bold leading-tight text-gray-900 dark:text-foreground">
                                Make Technology
                                <br />
                                Development
                                <br />
                                <span className="text-blue-500">Easy</span>
                            </h1>

                            {/* SUBTEXT */}
                            <p className="mt-6 text-lg text-gray-600 dark:text-muted-foreground max-w-2xl mx-auto leading-relaxed">
                                A powerful, collaborative LaTeX environment designed to handle
                                the complexity so you can focus on the breakthrough.
                            </p>

                            {/* MOCK IMAGE */}
                            <div className="mt-12 flex justify-center">
                                <img
                                    src="/mockDesktopImg.svg"
                                    alt="Rudrise Editor"
                                    className="w-[472px] h-[302px] object-contain md:w-[472px] md:h-[302px] w-[320px] h-auto"
                                />
                            </div>

                            {/* CTA */}
                            <div className="mt-12 flex flex-col items-center gap-2">
                                <Link href="https://latex-editor.rudrise.com">
                                    <Button
                                        size="lg"
                                        className="px-6 py-3 rounded-xl bg-blue-600 hover:bg-blue-700 dark:text-white shadow-md gap-2"
                                    >
                                        <svg
                                            className="w-5 h-5"
                                            fill="none"
                                            stroke="currentColor"
                                            viewBox="0 0 24 24"
                                        >
                                            <path
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                                strokeWidth={2}
                                                d="M4 16v8m0 0h8m-8-8l12-12m0 0h-8m8 0v-8"
                                            />
                                        </svg>
                                        Download Now
                                    </Button>
                                </Link>

                                <p className="text-xs text-gray-500 dark:text-muted-foreground">All downloads &gt;&gt;</p>
                            </div>

                        </div>

                    </div>
                </section>
            </main>
        </>
    );
}
